module.exports = __webpack_public_path__ + "static/media/homepage-section-6-phone-5.1ad01a47.png";